import styled from 'styled-components';

const AlertPanel = styled.div`
    z-index: 1;
    pointer-events: all;
    background-color: transparent;
    padding: 8px 8px 8px 8px;
    grid-column: controls-end / instrument-start;
    grid-row: alert-bar-top / alert-bar-bottom;
`;

export default AlertPanel;
